
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TransportBidInfoDto, TransportBidServiceProxy, UpdateTransportBidDto, UpdateTransportBidDtoTeklifDurum } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'kt-test1',
  templateUrl: './test1.component.html',
  styleUrls: ['./test1.component.scss']
})
export class Test1Component implements OnInit {

  id : string ;//= "1EBB397C-2F2B-EB11-912B-005056012243" //guid NakliyeTeklif Id (Header UD degil)
  bidInfo$ : Subject<TransportBidInfoDto> = new Subject<TransportBidInfoDto>();
  price : number ;
  formEnd$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	
  constructor(
    private _route: ActivatedRoute,
    private _trasportBidService : TransportBidServiceProxy
  ) { 

  
    //Tedarikci teklif entityID (querystring ile gelir)
   this.id = _route.snapshot.params.bidId ;

  }

  ngOnInit() {
      this.loadBidInfo();
  }

  loadBidInfo(){
    this._trasportBidService
        .getBidContent(this.id)
        .subscribe(res => {
            this.bidInfo$.next(res);
        });
  }

  onSubmit(status){

    let bidInput : UpdateTransportBidDto = new UpdateTransportBidDto();
    bidInput.id = this.id ;
    

    if (status == 0){
      bidInput.teklifDurum = UpdateTransportBidDtoTeklifDurum.Ilgilenmiyor ;
      alert("İlgilenmediğinizden emin misiniz?");
      
    }else if (status == 1) //Teklif ile ilgineniyorsa.
    {
      if (this.price > 0){
          
        bidInput.teklifTutari = this.price ;
        bidInput.teklifDurum = UpdateTransportBidDtoTeklifDurum.Teklif_Girisi_Yapildi ;
      }
    }

    //Send to server
    this._trasportBidService
      .updateBidPrice(bidInput)
      .pipe(
        finalize(() => {
          this.formEnd$.next(true);
        })
      )
      .subscribe(res => {
        //
    });

  }

}
